<template>
  <div>
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="search-box mr-2 mb-4 mt-2">
      <div class="position-relative">
        <input type="text" class="form-control" v-model="filter.search" placeholder="Pesquise por Nome, E-mail ou CPF e pressione 'ENTER'" @keyup.enter="doSearch"/>
        <i class="bx bx-search-alt search-icon"></i>
      </div>
    </div>
    <div class="container-fluid custom-scroll" v-infinite-scroll="fetchListPage" infinite-scroll-disabled="busyRealized" infinite-scroll-distance="10">
      <div class="row row-item" v-for="item in realizedList" :key="'item-'+item.id">
        <div class="col texts-box text-truncate">
          <div class="text-1 text-truncate">{{ item.name }}</div>
          <div class="text-2 text-truncate">{{ item.email }}</div>
        </div>
        <div class="col-auto">
          <div class="fix-w">
            <b-button
              block
              :variant="filter.typeCheck === 'CheckedIn' ? 'success' : 'warning'"
            >
              <template v-if="filter.typeCheck === 'CheckedIn'">
                <i class="fas fa-check-circle"></i>
                Check In
              </template>
              <template v-else>
                <i class='bx bx-log-out-circle'></i>
                Check Out
              </template>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions } from 'vuex'
import infiniteScroll from 'vue-infinite-scroll'
import { errorMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  directives: { infiniteScroll },
  props: {
    filters: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      filter: {},
      busyRealized: false,
      realizedList: [],
      pagination: {
        currentPage: 0,
        total: 0,
        perPage: 20,
        totalPages: 0
      }
    }
  },
  created () {
    this.realizedList = []
    this.pagination.currentPage = 0
    this.pagination.total = 0
    this.pagination.totalPages = null
    this.loadItem(this.filters)
  },
  methods: {
    ...mapActions('settingcheck', {
      getParticipantByTagCheck: 'getParticipantByTagCheck'
    }),
    loadItem (id) {
      if (id) {
        this.filter = { ...id }
        this.fetchListPage()
      }
    },
    async fetchListPage () {
      this.busyRealized = true
      if (this.pagination.totalPages === this.pagination.currentPage) {
        this.busyRealized = false
        return
      }
      try {
        const res = await this.getParticipantByTagCheck(
          {
            page: this.pagination.currentPage + 1,
            limit: this.pagination.perPage,
            search: this.filter.search,
            tag: this.filter.tag,
            typeCheck: this.filter.typeCheck,
            checkin_date: this.filter.checkin_date ? this.$moment(this.filter.checkin_date).format('YYYY-MM-DD') : null
          }
        )
        this.pagination.currentPage = res.meta.pagination.current_page
        this.pagination.totalPages = res.meta.pagination.total_pages
        this.pagination.total = res.meta.pagination.total
        this.realizedList.push(...res.data.map(item => ({ ...item, onAction: false })))
      } catch (error) {
        console.log(error)
        errorMessage('Erro ao carregar mais itens da lista checks realizados.')
      } finally {
        this.busyRealized = false
        this.loading = false
        this.$emit('loadRealizedList', this.pagination.total)
      }
    },
    doSearch () {
      this.resetList()
      this.fetchListPage()
    },
    resetList () {
      this.realizedList = []
      this.pagination.total = 0
      this.pagination.currentPage = 0
      this.pagination.totalPages = null
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.test-scroll {
  max-height: 300px;
  overflow-y: auto;
}
.custom-scroll{
  overflow-y: auto;
  max-height: 300px;
  padding-bottom: 0;
}
.fix-w {
  --width: 100px;
  --font-size: 13px;
  --icon-size: 16px;
  --btn-justify: space-evenly;
  --btn-padding: 0.20rem 0.08rem;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 100px;
    --font-size: 13px;
    --icon-size: 16px;
    --btn-justify: space-around;
    --btn-padding: 0.20rem 0.35rem;
  }

  width: var(--width);

  button {
    font-size: var(--font-size);
    display: flex;
    align-items: center;
    justify-content: var(--btn-justify);
    padding: var(--btn-padding);

    i {
      font-size: var(--icon-size);
    }
  }
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 5px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(233, 233, 233, 0.59);
  align-items: center;
  cursor: pointer;
}
.texts-box {
  .text-1 {
    font-size: 14px;
    color: #05162B;
  }

  .text-2 {
    font-size: 12px;
    color: #05162B87;
  }
}
</style>
